var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      class: _vm.className + " custom_loading_btn",
      attrs: {
        tabindex: "-1",
        disabled: _vm.loading || _vm.disabled,
        type: _vm.type,
      },
      on: { click: _vm.onClick },
    },
    [
      !_vm.loading
        ? [
            _c("div", {
              staticClass: "button_title",
              domProps: { innerHTML: _vm._s(_vm.title) },
            }),
          ]
        : [
            _c("scale-loader", {
              staticClass: "loading_spinner",
              attrs: {
                loading: true,
                color: _vm.color || "white",
                height: "12px",
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }